import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'

import * as actions from '../../../store/actions'

import Aux from '../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../components/UI/Card/Card'
import CardBody from '../../../components/UI/Card/Body/Body'
import CardHeader from '../../../components/UI/Card/Header/Header'
import Alert from '../../../components/Alert/Alert'
import ActionBar from '../../../components/ActionBar/ActionBar'
import PageInfo from '../../../components/PageInfo/PageInfo'
import FilterModal from '../../../components/FilterModal/FilterModal'

import { updateFilterOptions, clearFilterOptionValues, updateObject } from '../../../helpers/utils'

import ForceRankPageContent from '../../../components/PageContent/HorizontalForceRank/ForceRankContent/ForceRankPageContent'

import PleaseFilter from '../../../components/PleaseFilter/PleaseFilter'
import Spinner from '../../../components/UI/Spinner/Spinner'
import _ from 'lodash'
import { getPureNumber } from '../../../helpers'
class HorizontalForceRankBoard extends Component {
  state = {
    data: [],
    filterData: [],
    filter: {},
    dataTable: [],
    forceRankTable: [],
    filterModalOpen: false,
    gradeTable: [],
    gradeData: [],
    dataList: [],
    total_amount: 0,
    total_budget: 0,
    gradeSelect: [],
    adjustSave: {},
    checkCalculate: false,
    gradeAlert: [],
    gradeTotal: {},
    totalAdjust: [],
    fetchEmp: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        },
        required: true
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          options: []
        }
      }
    },
    showTable: false,
    filterOptions: {
      companyFilterOptions: null,
      formFilterOptions: null,
      gradeOptions: null,
      levelFilterOptions: null
    },
    showStatus: false
  }

  componentDidMount () {
    this.props.fetchAppraisalTypes()
    // this.props.fetchForceRankGrade()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchFilterOptions({
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
    }
    // if (this.props.success && prevProps.success !== this.props.success) {
    //   window.location.reload(false)
    // }
  }

  componentWillUnmount () {
    this.clearFilter()
    this.props.clearHorizontalRecord()
  }

  static getDerivedStateFromProps (props, state) {
    let updateState = { ...state }
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select Company'
      )

      updateState = {
        ...updateState,
        filterControls: updateObject(state.filterControls, { company_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }

    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      let updateFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions.filter(item => item.is_force_rank === 1),
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      updateState = {
        ...updateState,
        filterControls: updateObject(state.filterControls, {
          form_id: updateFilterItem
        }),
        filterOptions: {
          ...state.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }

    if (props.filterOptions.levelFilterOptions !== state.filterOptions.levelFilterOptions) {
      const levelFilter = state.filterControls.level_group_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.levelFilterOptions,
        levelFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select Level'
      )
      updateState = {
        ...updateState,
        filterControls: updateObject(state.filterControls, { level_group_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          levelFilterOptions: props.filterOptions.levelFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== state.filterOptions.orgFilterOptions) {
      const orgFilter = state.filterControls.org_id
      const updateFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        'org_name'
      )
      updateState = {
        ...updateState,
        filterControls: updateObject(state.filterControls, { org_id: updateFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (props.gradeData !== state.gradeTable) {
      let gradeTable = props.gradeData.map(item => {
        return {
          ...item,
          checkAmount: 0,
          budget: 0,
          amount: 0
        }
      })
      const gradeSelect = props.gradeData.map(item => {
        return {
          key: item.value_list_id,
          value: item.value_list_id,
          label: item.value_list_name
        }
      })
      updateState = {
        ...updateState,
        gradeTable: props.gradeData,
        gradeSelect: gradeSelect,
        gradeData: gradeTable
      }
    }
    if (props.dataTable !== state.dataTable) {
      let forceRankTable = []
      let updateGradeData = state.gradeData
      let showStatus = false
      if (props.dataTable?.emp_not_vfrb) {
        let status = ''
        props.dataTable.emp_not_vfrb.map((item, index) => {
          if (item?.result_structure) {
            item.result_structure.map(str => {
              if (!['CLS', 'VFR', 'DFR', 'HFR'].includes(str?.status_code)) {
                status = 'in Evaluation Process'
                showStatus = true
              } else if (str?.status_code === 'CLS') {
                status = 'to Vertical Force Rank'
                showStatus = true
              } else if (str?.status_code === 'VFR') {
                status = 'to Horizontal Director'
                showStatus = true
              }
              return str
            })
          }
          forceRankTable.push({
            no: index + 1,
            emp_code: item.emp_detail.emp.emp_code,
            emp_name: item.emp_detail.emp.full_name,
            level_name: item.emp_detail.level.level_name,
            position_name: item.emp_detail.position.position_name,
            org_name: item.emp_detail.org.org_name,
            extra_raise_amount: 0,
            extra_raise: 0,
            extra_bonus_month: 0,
            extra_bonus: 0,
            final_bonus: 0,
            status: status
          })
          return item
        })
        updateState = {
          ...updateState,
          total_amount: 0,
          total_budget: 0,
          showStatus: showStatus
        }
      } else if (props.dataTable?.grade_table) {
        let total_amount = props.dataTable?.total_amount
        props.dataTable.grade_table.map(data => {
          updateGradeData = updateGradeData.map(item => {
            if (item.value_list_id === data.value_list_id) {
              return {
                ...item,
                checkAmount: (total_amount * (+data.grade_budget / 100)).toFixed(0),
                budget: +data.grade_budget || 0,
                amount: (total_amount * (+data.grade_budget / 100)).toFixed(0)
              }
            } else {
              return item
            }
          })
          return data
        })
        updateState = {
          ...updateState,
          total_amount: props.dataTable?.total_amount,
          total_budget: props.dataTable?.total_budget,
          showStatus: showStatus
        }
      }
      updateState = {
        ...updateState,
        gradeData: updateGradeData,
        forceRankTable: forceRankTable,
        dataTable: props.dataTable
      }
    }
    if (props.dataList !== state.dataList || !_.isEqual(props.dataList, state.dataList)) {
      let updateForceRankTable = []
      let updateAdjustSave = props.dataList
      let checkCal = false
      let gradeTotal = {}
      Object.entries(props.dataList).map(item => {
        let [key, attr] = item
        gradeTotal = {
          ...gradeTotal,
          [key]: attr.length
        }
        let grade = state.gradeTable.find(grade => grade.value_list_name === key)
        updateAdjustSave[key] = updateAdjustSave[key].map(adjust => {
          return {
            ...adjust,
            adjust_grade:
              state.dataList.length === 0 || !adjust.adjust_grade
                ? grade?.value_list_id
                : adjust?.adjust_grade
          }
        })
        attr.map(att => {
          if (!state.fetchEmp && att?.adjust_grade) {
            grade = state.gradeTable.find(grade => +grade.value_list_id === +att.adjust_grade)
            checkCal = true
            updateState = {
              ...updateState,
              fetchEmp: false
            }
          } else if (att.grade_id !== null) {
            checkCal = true
          }
          // let adjust = null
          // if (state.forceRankTable.length > 0) {
          //   adjust = state.forceRankTable.find(
          //     item => item.emp_code === att.emp_detail.emp.emp_code
          //   )
          // }
          updateAdjustSave[key] = updateAdjustSave[key].map(adjust => {
            return {
              ...adjust,
              extra_raise_amount: +(+att?.salary * (+att?.extra_raise_amount / 100)) || 0,
              extra_raise: +(+att?.salary * (+att?.extra_raise / 100)) || 0,
              extra_bonus_month: +(+att?.extra_bonus / +att?.salary) || 0,
              extra_bonus: +(+att?.extra_bonus_month * +att?.salary) || 0,
              adjust_grade:
                state.dataList.length === 0 || !adjust.adjust_grade
                  ? grade?.value_list_id
                  : adjust?.adjust_grade
            }
          })
          updateForceRankTable.push({
            ...att,
            no: updateForceRankTable.length + 1,
            emp_code: att.emp_detail.emp.emp_code,
            emp_name: att.emp_detail.emp.full_name,
            level_name: att.emp_detail.level.level_name,
            position_name: att.emp_detail.position.position_name,
            org_name: att.emp_detail.org.org_name,
            grade: key,
            adjust_grade: {
              key: grade?.value_list_id,
              value: grade?.value_list_id,
              label: grade?.value_list_name
            },
            extra_raise_amount: +(+att?.salary * (+att?.extra_raise_amount / 100)) || 0,
            extra_raise: +(+att?.salary * (+att?.extra_raise / 100)) || 0,
            extra_bonus_month: +(+att?.extra_bonus / +att?.salary) || 0,
            extra_bonus: +(+att?.extra_bonus_month * +att?.salary) || 0,
            bonus: +att?.bonus || 0,
            new_salary: +(+att?.salary + +att?.raise_amount + +att?.extra_raise_amount) || 0,
            final_bonus: +(+att?.bonus + +att?.extra_bonus) || 0
          })

          return att
        })
        return item
      })
      if (state.forceRankTable.length > 0) {
        updateForceRankTable = updateForceRankTable.map(item => {
          let check = state.forceRankTable.find(ad => ad.emp_code === item.emp_code)
          if (check) {
            return {
              ...item,
              adjust_grade: check.adjust_grade
            }
          }
          return item
        })
      }
      if (state.gradeData.length > 0) {
        let total = {}
        updateForceRankTable.map(item => {
          if (total?.[item.adjust_grade.label]) {
            total = {
              ...total,
              [item.adjust_grade.label]: total[item.adjust_grade.label] + 1
            }
          } else {
            total = {
              ...total,
              [item.adjust_grade.label]: 1
            }
          }
          return item
        })
        state.gradeData.map(gra => {
          let checkTotal = Object.keys(total).find(to => gra.value_list_name === to)
          if (!checkTotal) {
            total = {
              ...total,
              [gra.value_list_name]: 0
            }
          }
          return gra
        })
        let checkTotal = []

        Object.entries(total).map(item => {
          let [key, val] = item
          let grade = state.gradeData.find(g => g.value_list_name === key)
          if (grade && +grade.amount !== val) {
            checkTotal.push(`${key} ${+grade.amount - +val > 0 ? '+' : ''}${+grade.amount - +val}`)
          }
          // if (total[key] !== state.gradeTotal[key]) {
          //   checkTotal.push(key)
          // }
          return item
        })
        updateState = {
          ...updateState,
          totalAdjust: checkTotal
        }
      }
      console.log(props.dataList, updateAdjustSave)

      updateState = {
        ...updateState,
        adjustSave: updateAdjustSave,
        gradeTotal: gradeTotal,
        forceRankTable: updateForceRankTable,
        dataList: props.dataList,
        checkCalculate: checkCal
      }
    }
    return updateState
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }
  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    const updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })
    const appraisalTypeId = this.props.appraisalType?.appraisal_type_id
    const filterOptions = {
      appraisal_type_id: appraisalTypeId,
      company_id: updatedFilterControls.company_id?.value?.value,
      org_id: updatedFilterControls.org_id?.value?.value,
      level_group_id: updatedFilterControls.level_group_id?.value?.value
    }

    if (itemKey === 'company_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchFormOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrgOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }
  filterRecords = (groupBy = 'group_by_budget') => {
    let param = {
      company_id: this.state.filterControls.company_id.value.value,
      level_group_id: this.state.filterControls.level_group_id.value.value,
      form_id: this.state.filterControls.form_id.value.value,
      org_id: this.state.filterControls.org_id.value?.value
    }
    this.setState({
      // data: [],
      // filterData: [],
      // filter: {},
      // dataTable: [],
      // forceRankTable: []
      // filterModalOpen: false,
      // gradeData: [],
      // dataList: [],
      // total_amount: 0,
      // total_budget: 0,
      // gradeSelect: [],
      // adjustSave: {},
      // checkCalculate: false,
      // gradeAlert: [],
      // gradeTotal: {},
      // totalAdjust: [],
      // fetchEmp: false
      adjustSave: {},
      showTable: false,
      dataList: [],
      gradeData: [],
      forceRankTable: [],
      dataTable: []
    })
    // this.props.fetchForceRankFilter(param)
    // this.props.clearHorizontalRecord()
    this.props.fetchForceRankGrade()
    this.props.fetchAdjust(param)
    this.props.fetchHorizontalForceRank({ ...param, groupBy })
    this.closeFilterModal()
  }

  amountChanged = (type, id, e) => {
    let updateGradeData = this.state.gradeData.map(item => {
      if (item.value_list_id === id) {
        return {
          ...item,
          [type]: +e.target.value >= 0 ? e.target.value : item[type]
        }
      } else {
        return item
      }
    })
    this.setState({
      gradeData: updateGradeData
    })
  }
  forceRank = () => {
    let data = []
    let sum = 0
    let check = []
    let param = {}
    Object.entries(this.state.filterControls).map(item => {
      let [key, att] = item
      param = {
        ...param,
        [key]: att.value.value
      }
      return item
    })
    this.state.gradeData.map(item => {
      data.push(+item?.amount || 0)
      sum = sum + +item?.amount || 0
      // if (item.amount > +item.checkAmount + 1 || item.amount < +item.checkAmount - 1) {
      //   check.push(item.value_list_name)
      // }
      return item
    })
    if (sum === this.state.total_amount) {
      if (check.length > 0) {
        // this.props.fireAlert({
        //   message: `Error : ${check.toString()} +/-ไม่เกิน1`,
        //   options: {
        //     variant: 'error'
        //   }
        // })
      } else {
        this.props.fetchEmpList({ ...param, grade: data })
        this.setState({
          fetchEmp: true
        })
      }
    } else {
      this.props.fireAlert({
        message: 'Error : Grade is not equal to total_amount',
        options: {
          variant: 'error'
        }
      })
    }
    this.setState({
      showTable: true
    })
  }
  gradeChanged = (data, e) => {
    let total = {}
    let updateForceRankTable = [...this.state.forceRankTable].map(item => {
      if (item.emp_code === data.emp_code) {
        return {
          ...item,
          adjust_grade: e
        }
      } else {
        return item
      }
    })
    updateForceRankTable.map(item => {
      if (total?.[item.adjust_grade.label]) {
        total = {
          ...total,
          [item.adjust_grade.label]: total[item.adjust_grade.label] + 1
        }
      } else {
        total = {
          ...total,
          [item.adjust_grade.label]: 1
        }
      }
      return item
    })
    this.state.gradeData.map(gra => {
      let checkTotal = Object.keys(total).find(to => gra.value_list_name === to)
      if (!checkTotal) {
        total = {
          ...total,
          [gra.value_list_name]: 0
        }
      }
      return gra
    })
    let updateAdjustSave = { ...this.state.adjustSave }
    let keyGroup = Object.keys(updateAdjustSave)
    keyGroup.map(key => {
      updateAdjustSave[key] = updateAdjustSave[key].map(item => {
        if (item.emp_detail.emp.emp_code === data.emp_code) {
          return {
            ...item,
            adjust_grade: e.value
          }
        } else {
          return item
        }
      })
      return key
    })
    // let checkTotal = []
    // Object.entries(total).map(item => {
    //   let [key] = item
    //   if (total[key] !== this.state.gradeTotal[key]) {
    //     checkTotal.push(key)
    //   }
    //   return item
    // })
    let checkTotal = []

    Object.entries(total).map(item => {
      let [key, val] = item
      let gradeFind = this.state.gradeData.find(g => g.value_list_name === key)
      if (gradeFind && +gradeFind.amount !== val) {
        checkTotal.push(
          `${key} ${+gradeFind.amount - +val > 0 ? '+' : ''}${+gradeFind.amount - +val}`
        )
      }
      // if (total[key] !== state.gradeTotal[key]) {
      //   checkTotal.push(key)
      // }
      return item
    })
    this.setState({
      fetchEmp: false,
      totalAdjust: checkTotal,
      forceRankTable: updateForceRankTable,
      updateAdjustSave: updateAdjustSave,
      adjustSave: updateAdjustSave
    })
  }
  createForceRank = () => {
    let param = {
      company_id: this.state.filterControls.company_id.value.value,
      level_group_id: this.state.filterControls.level_group_id.value.value,
      org_id: this.state.filterControls.org_id.value?.value,
      form_id: this.state.filterControls.form_id.value.value
    }
    let hfr = []
    let fr = []
    fr = this.state.forceRankTable.map(item => {
      return {
        company_id: item.company_id,
        result_id: item.result_id,
        grade_id: item.adjust_grade.value,
        // mg_id: item.adjust_grade.value,
        bg_id: item.adjust_grade.value,
        sa: item.salary,
        rp: item['raise_%'],
        ra: item.raise_amount,
        nsa: item.new_salary,
        bm: item.bonus_month,
        ba: item.bonus,
        era: item.extra_raise_amount,
        erp: item.extra_raise,
        ebm: item.extra_bonus_month,
        eba: item.extra_bonus,
        fb: item.final_bonus,
        ex_raise_amount: item.extra_raise_amount,
        ex_raise_percent: item.extra_raise,
        ex_bonus_month: item.extra_bonus_month,
        ex_bonus: item.extra_bonus
      }
    })
    hfr = this.state.gradeData.map(item => {
      return {
        // company_id: 1,
        // level_group_id: 1,
        // form_id: 1,
        ...param,
        grade_id: item.value_list_id,
        budget_percent: item.budget,
        budget_emp: item.amount
      }
    })
    this.props.createForceRank(this.state.filterControls.company_id.value.value, { fr, hfr })
  }
  calculateForceRank = () => {
    let updateSave = {
      calculate_data: this.state.adjustSave,
      company_id: this.state.filterControls.company_id.value.value,
      form_id: this.state.filterControls.form_id.value.value
    }
    this.props.fetchForceRankFilter(updateSave)
  }
  forceRankTableChanged = (key, data, e) => {
    // let total = {}
    let updateForceRankTable = [...this.state.forceRankTable].map(item => {
      if (item.emp_code === data.emp_code) {
        if (key === 'extra_raise_amount') {
          return {
            ...item,
            [key]: e,
            extra_raise: getPureNumber(100 * (+e / +item?.salary), 2),
            new_salary: getPureNumber(+item?.salary + item?.raise_amount + +e, 2)
          }
        } else if (key === 'extra_raise') {
          return {
            ...item,
            [key]: e,
            extra_raise_amount: getPureNumber(+item?.salary * (+e / 100), 2),
            new_salary: getPureNumber(
              +item?.salary + +item?.salary * (+e / 100) + +item?.raise_amount,
              2
            )
          }
        } else if (key === 'extra_bonus_month') {
          return {
            ...item,
            [key]: e,
            extra_bonus: getPureNumber(+item?.salary * +e, 2),
            final_bonus: getPureNumber(+item?.bonus + +item?.salary * +e, 2)
          }
        } else if (key === 'extra_bonus') {
          return {
            ...item,
            [key]: e,
            extra_bonus_month: getPureNumber(+e / +item?.salary, 2),
            final_bonus: getPureNumber(+e + +item?.bonus, 2)
          }
        }
        return {
          ...item,
          [key]: e
        }
      } else {
        return item
      }
    })

    // updateForceRankTable.map(item => {
    //   if (total?.[item.adjust_grade.label]) {
    //     total = {
    //       ...total,
    //       [item.adjust_grade.label]: total[item.adjust_grade.label] + 1
    //     }
    //   } else {
    //     total = {
    //       ...total,
    //       [item.adjust_grade.label]: 1
    //     }
    //   }
    //   return item
    // })
    // this.state.gradeData.map(gra => {
    //   let checkTotal = Object.keys(total).find(to => gra.value_list_name === to)
    //   if (!checkTotal) {
    //     total = {
    //       ...total,
    //       [gra.value_list_name]: 0
    //     }
    //   }
    //   return gra
    // })
    // let updateAdjustSave = { ...this.state.adjustSave }
    // let keyGroup = Object.keys(updateAdjustSave)
    // keyGroup.map(key => {
    //   updateAdjustSave[key] = updateAdjustSave[key].map(item => {
    //     if (item.emp_detail.emp.emp_code === data.emp_code) {
    //       return {
    //         ...item,
    //         adjust_grade: e.value
    //       }
    //     } else {
    //       return item
    //     }
    //   })
    //   return key
    // })
    // // let checkTotal = []
    // // Object.entries(total).map(item => {
    // //   let [key] = item
    // //   if (total[key] !== this.state.gradeTotal[key]) {
    // //     checkTotal.push(key)
    // //   }
    // //   return item
    // // })
    // let checkTotal = []

    // Object.entries(total).map(item => {
    //   let [key, val] = item
    //   let gradeFind = this.state.gradeData.find(g => g.value_list_name === key)
    //   if (gradeFind && +gradeFind.amount !== val) {
    //     checkTotal.push(
    //       `${key} ${+gradeFind.amount - +val > 0 ? '+' : ''}${+gradeFind.amount - +val}`
    //     )
    //   }
    //   // if (total[key] !== state.gradeTotal[key]) {
    //   //   checkTotal.push(key)
    //   // }
    //   return item
    // })
    this.setState({
      forceRankTable: updateForceRankTable
    })
  }
  render () {
    let content = <PleaseFilter />
    if (this.props.filtered) {
      if (this.props.dataTable === []) {
        content = <Spinner />
      } else {
        content = (
          <ForceRankPageContent
            isBoard={true}
            data={this.props.data}
            forceRankTable={this.state.forceRankTable}
            isAdmin={this.props.isAdmin}
            horizontalForceRankLoading={this.props.horizontalForceRankLoading}
            groupByChanged={groupBy => this.filterRecords(groupBy)}
            headerData={this.props.dataTable}
            adjustData={this.props.adjustData}
            gradeData={this.state.gradeData}
            gradeTable={this.state.gradeTable}
            tableLoading={this.props.tableLoading}
            filterControls={this.state.filterControls}
            filterData={this.props.filterData}
            amountChanged={this.amountChanged}
            loading={this.props.loading}
            gradeTotal={this.state.gradeTotal}
            totalAdjust={this.state.totalAdjust}
            fetchEmpList={() => this.forceRank()}
            showTable={this.state.showTable}
            gradeChanged={(data, e) => this.gradeChanged(data, e)}
            calculateClicked={this.calculateForceRank}
            disableForceRank={this.props.dataTable?.emp_not_vfrb}
            createForceRank={() => {
              this.createForceRank()
            }}
            disbleSave={!this.state.checkCalculate || this.props.dataTable?.emp_not_vfrb}
            fetchForceRankList={param => {
              this.props.fetchForceRankList(param)
            }}
            total_budget={this.state.total_budget}
            total_amount={this.state.total_amount}
            gradeOptions={this.state.gradeSelect}
            type={'horizontal'}
            forceRankTableChanged={(key, data, e) => this.forceRankTableChanged(key, data, e)}
            showStatus={this.state.showStatus}
          />
        )
      }
    }

    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={() => this.filterRecords()}
          filterChanged={(itemKey, event) => this.filterChangedHandler(itemKey, event)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoadingQueue}
        />
        <Alert />
        <Card>
          <CardHeader>
            <ActionBar
              filtering={this.openFilterModal}
              show={['filter']}
              leftContent={<PageInfo pageTranslateKey={'forceRankHorizontalBoard'} />}
            />
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.individualAssignment.appraisalTypes.find(item => {
    return item.appraisal_type_code === 'APT02'
  })

  return {
    appraisalType: appraisalType,
    pagination: state.horizontalForceRank.pagination,
    horizontalForceRankLoading: state.horizontalForceRank.horizontalForceRankLoading,
    filtered: state.horizontalForceRank.filtered,
    filterLoadingQueue: state.horizontalForceRank.filterLoadingQueue,
    filterData: state.horizontalForceRank.filterData,
    filterLoading: state.horizontalForceRank.filterLoading,
    tableLoading: state.horizontalForceRank.tableLoading,
    loading: state.horizontalForceRank.loading,
    pageLoading:
      state.horizontalForceRank.filterLoading ||
      state.horizontalForceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.horizontalForceRank.filterCompanies,
      formFilterOptions: state.horizontalForceRank.filterForms,
      orgFilterOptions: state.horizontalForceRank.filterOrgs,
      gradeOptions: state.horizontalForceRank.gradeData,
      levelFilterOptions: state.horizontalForceRank.filterLevelGroups
    },
    data: state.horizontalForceRank.data,
    adjustData: state.horizontalForceRank.adjustData,
    gradeData: state.horizontalForceRank.gradeData,
    dataTable: state.horizontalForceRank.dataTable,
    dataList: state.horizontalForceRank.dataList,
    success: state.horizontalForceRank.success
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchHorizontalForceRank: param => dispatch(actions.fetchHorizontalForceRankBoard(param)),
    fetchAdjust: param => dispatch(actions.fetchAdjust(param)),
    fetchForceRankList: param => dispatch(actions.fetchHorizontalForceRankList(param)),
    fetchEmpList: param => dispatch(actions.fetchReStoreHorizontalForceRankList(param)),
    createForceRank: (data, forceRankdata) =>
      dispatch(actions.createHorizontalForceRankBoard(data, forceRankdata)),
    fetchForceRankGrade: () => dispatch(actions.fetchHorizontalForceRankGrade()),
    fetchForceRankFilter: filterOptions =>
      dispatch(actions.fetchHorizontalForceRankBoardFilter(filterOptions)),
    fireAlert: alertOption => {
      dispatch(actions.enqueueSnackbar(alertOption))
    },
    fetchAppraisalTypes: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilterOptions: filterOptions => {
      dispatch(actions.fetchCompanyOptionsForAppraisal(filterOptions))
    },
    fetchFormOptions: filterOptions => {
      dispatch(actions.fetchFormOptionsForAppraisal(filterOptions))
    },
    fetchOrgOptions: filterOptions => {
      dispatch(actions.fetchOrganizationOptionsForAppraisal({ ...filterOptions, only_me: true }))
    },
    fetchLevelGroupOptions: filterOptions => {
      dispatch(actions.fetchLevelGroupOptionsForAppraisal({ ...filterOptions, not_me: true }))
    },
    clearHorizontalRecord: () => {
      dispatch(actions.clearHorizontalRecord())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(HorizontalForceRankBoard))
